/**
 * Created by ModelParser
 * Date: 05-03-2022.
 * Time: 18:07.
 */
import {ClientDefinition} from './definitions/ClientDefinition';

export class Client extends ClientDefinition {

    constructor(json?: any) {
        super(json);
    }

    public get name(): string {
        return `${this.first_name} ${this.last_name}`;
    }

}
